// React builder
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Avatar,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Tooltip,
  Divider,
  Button
} from "@mui/material";

// Styles
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";

// App Icons
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SecurityIcon from '@mui/icons-material/Security';
import BusinessIcon from '@mui/icons-material/Business';

//Auth
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Sidebar + Logout---------------- 
import Sidebar from "./Sidebar";
import Logout from "./Logout";

//SessionTimeOut
//import SessionTimeout from "./SessionTimeout";

// Company 
import CompanyEdit from "./components/pages/Company/Edit";

// Home
import Home from "./components/pages/Home";

// Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//Item 
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemIndex from "./components/pages/Item/Index";

// User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//Category
import CategoryCreate from "./components/pages/Category/Create";
import CategoryEdit from "./components/pages/Category/Edit";
import CategoryIndex from "./components/pages/Category/Index";

//Work
import WorkCreate from "./components/pages/Work/Create";
import WorkIndex from "./components/pages/Work/Index";
import WorkEdit from "./components/pages/Work/Edit";

//Work Items
import WorkItemCreate from "./components/pages/WorkItem/Create";

//Work Details
import WorkDetailsCreate from "./components/pages/WorkDetails/Create";
import WorkDetailsIndex from "./components/pages/WorkDetails/Index";
import WorkDetailsEdit from "./components/pages/WorkDetails/Edit";

//Customer 
import CustomerCreate from "./components/pages/Customer/Create";
import CustomerIndex from "./components/pages/Customer/Index";
import CustomerEdit from "./components/pages/Customer/Edit";

//Quotation 
// import CustomerCreate from "./components/pages/Customer/Create";
import QuotationIndex from "./components/pages/Quotation/Index";
import QuotationCreate from "./components/pages/Quotation/Create";
import QuotationDetails from "./components/pages/Quotation/Details";
import QuotationEdit from "./components/pages/Quotation/Edit";
import RevisionQuotationCreate from "./components/pages/Quotation/RevCreate";
import QuotationRevisionDetails from "./components/pages/Quotation/RevDetails";
import RevisionQuotationEdit from "./components/pages/Quotation/RevEdit";

// Invoice
import InvoiceIndex from "./components/pages/Invoice/Index";
import InvoiceDetails from "./components/pages/Invoice/Details";

//Terms & Conditions
import TermsAndConditions from "./components/pages/TermsAndCondition/Index";
import RevisionQuotationIndex from "./components/pages/Quotation/RevIndex";

// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: { main: "#34332f" },
    secondary: { main: "#34332f" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [hoverOpen, setHoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { companyName, roleName, username } = useAuth();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Header */}
        <AppBar position="fixed" color="primary" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }} style={{ height: '55px' }}>
          <Toolbar>
            <IconButton color="inherit" onClick={() => setSidebarOpen(!sidebarOpen)}>
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h6"
              sx={{ flexGrow: 1, ml: 2, fontWeight: "bold", textTransform: "uppercase" }}
            >
              <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                <span style={{ fontFamily: 'Verdana, sans-serif', fontSize: '14px' }}>{companyName}</span>
              </Link>
            </Typography>

            <div className="white-icon" style={{ display: 'flex', alignItems: 'center', marginTop: '-5px', }} >
              <div style={{ display: 'flex', alignItems: 'center', }} >
                <Logout />
              </div>
            </div>
          </Toolbar>
        </AppBar>

        {/* Sidebar */}
        {username !== "Counter" && (
          <Box
            onMouseEnter={() => setHoverOpen(true)}
            onMouseLeave={() => setHoverOpen(false)}
          >
            <Sidebar open={sidebarOpen || hoverOpen} roleName={roleName} />
          </Box>
        )}

        {/* Content */}
        <Box
          sx={{
            ml: sidebarOpen || hoverOpen ? "240px" : "60px",
            pt: 10,
            transition: "0.3s",
          }}
        >
          <Container maxWidth="xl">
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />
              {/* Role */}
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />
              {/* User */}
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/PasswordChange" component={PasswordChange} />
              {/* Work */}
              <Route path="/WorkIndex" component={WorkIndex} />
              <Route path="/WorkCreate" component={WorkCreate} />
              <Route path="/WorkEdit/:id" component={WorkEdit} />
              {/* Work Items */}
              {/* <Route path="/WorkDetailsIndex" component={WorkDetailsIndex} />
            <Route path="/WorkDetailsEdit/:id" component={WorkDetailsEdit} /> */}
              <Route path="/WorkItemCreate/:id" component={WorkItemCreate} />
              {/* Work Details */}
              <Route path="/WorkDetailsIndex" component={WorkDetailsIndex} />
              {/* <Route path="/WorkDetailsCreate" component={WorkDetailsCreate} /> */}
              <Route path="/WorkDetailsEdit/:id" component={WorkDetailsEdit} />
              <Route path="/WorkDetailsCreate/:id" component={WorkDetailsCreate} />
              {/* Customer */}
              <Route path="/CustomerIndex" component={CustomerIndex} />
              <Route path="/CustomerCreate" component={CustomerCreate} />
              <Route path="/CustomerEdit/:id" component={CustomerEdit} />
              {/* Customer */}
              <Route path="/QuotationIndex" component={QuotationIndex} />
              <Route path="/QuotationCreate" component={QuotationCreate} />
              <Route path="/QuotationDetails/:id" component={QuotationDetails} />
              <Route path="/QuotationEdit/:id" component={QuotationEdit} />
              {/* Revision QA */}
              <Route path="/RevisionQuotationCreate/:id" component={RevisionQuotationCreate} />
              <Route path="/QuotationRevisionDetails/:id" component={QuotationRevisionDetails} />
               <Route path="/RevisionQuotationEdit/:id" component={RevisionQuotationEdit} />
               <Route path="/RevisionQuotationIndex" component={RevisionQuotationIndex} />
              {/* Invoice */}
              <Route path="/InvoiceIndex" component={InvoiceIndex} />
              <Route path="/InvoiceDetails/:id" component={InvoiceDetails} />
              {/* Company */}
              <Route path="/CompanyEdit" component={CompanyEdit} />
              {/* Terms & Conditions */}
              <Route path="/TermsAndConditions" component={TermsAndConditions} />
            </Switch>
          </Container>

        </Box>
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
